module.exports = __webpack_public_path__ + "img/stress.7dac145.jpg";